import { UnavailabilityError } from 'expo-modules-core';

export default function AdSettings() {
  throw new UnavailabilityError('expo-ads-facebook', 'AdSettings');
}
